module.exports = __webpack_public_path__ + "style/img/tongyi.f71f45a9.jpg";